import React, { useState, useRef, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../../components/useTable";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoAgenteTipo2 from "../../catalogos/catalogoAgenteTipo2";
import moment from "moment";
import CatalogoAgenteTipo2Web from "../../catalogos/catalogoAgenteTipo2Web";

function GuiasMovilizacionWeb() {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> ID</i>,
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> TALONARIO</i>,
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> CODIGO</i>,
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> ESTATUS</i>,
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> FECHA</i>,
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> GUIA</i>,
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> FACTURA</i>,
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> MOTIVO</i>,
      textAlign: "center",
    },
  ];

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const txtCantidadTalonarios = useRef();
  const txtIdExpendedor = useRef();

  const [activate, setActivate] = useState(false);
  const [expendedor, setExpendedor] = useState();
  const [inhabilitado, setInhabilitado] = useState(true);
  const [mostrarcatalogo, setMostrarcatalogo] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [planillas, setPlanillas] = useState([]);
  const [records, setRecords] = useState([]);
  const [estatus, setEstatus] = useState(1);

  const txtBuscador = useRef();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtalonarioguia.includes(target.value) ||
              x.idguiadetalle.includes(target.value) ||
              x.codigoguia.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarTalonarios = (idagente, status) => {
    console.log(idagente);

    if (idagente !== null && idagente !== "") {
      let campos = "gd.*";
      let nomtab =
        "guiadetalle as gd inner join talonarioguia as tg on gd.idtalonarioguia=tg.idtalonarioguia";
      let condi = `tg.idmina=${idagente} and gd.estatusguia=${status}`;
      let orden = "gd.idguiadetalle";

      setActivate(true);
      let endpoint = `${op.conexion}/api/consultaweb/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setRecords(response.data);
          }
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        })
        .finally(function () {
          setActivate(false);
        });
    }
  };

  /////#####proceso para generar las planillas#####/////

  /////#####$$$$$#####/////

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquearExpendedor = () => {
    setExpendedor();
    txtIdExpendedor.current.value = "";
    txtCantidadTalonarios.current.value = "1";
    setInhabilitado(true);
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar el expendedor desde el catalogo#####/////
  const seleccionarExpendedor = (idage, nombage, status, direcc, nre, nli) => {
    if (status === "52") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "la mina no se encuentra Activa.",
        icono: "informacion",
      });
      txtIdExpendedor.current.value = "";
      blanquearExpendedor();
      setInhabilitado(true);
    } else {
      setExpendedor({
        idagente: idage,
        status: status,
        nombre: nombage,
        direccion: direcc,
        nroresolucion: nre,
        nrolicencia: nli,
      });
      // gestionartimbredetalle(idage);
      txtIdExpendedor.current.value = idage;
      setInhabilitado(false);
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir el catalogo de expendedores#####/////
  const catalogoExpendedor = () => {
    setMostrarcatalogo(true);
  };
  /////#####$$$$$#####/////

  /////#####funcion para cerrar el catalogo de expendedores#####/////
  const cerrarCatalogo = () => {
    setMostrarcatalogo(false);
  };

  const buscarExpendedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        gestionarExpendedor(event.target.value);
      }
    }
  };

  const gestionarExpendedor = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let id2 = true;
    let nomid2 = "mina";
    let orden = "idagente";

    let endpoint = `${op.conexion}/api/consulta/idsstring2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            if (response.data.statusmina === "52") {
              setInhabilitado(true);
              blanquearExpendedor();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "la mina no se encuentra Activa.",
                icono: "informacion",
              });
            } else {
              setExpendedor(response.data);
              SeleccionarTalonarios(response.data.idagente, 1);
              setInhabilitado(false);
              //gestionartimbredetalle(response.data.idagente);
            }
          } else {
            blanquearExpendedor();
            setInhabilitado(true);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una mina con ese codigo",
              icono: "informacion",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        console.log(error);

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const verImagen = (value) => {
    window.open(
      `${op.imagenesweb}${value}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <div className="container-fluid px-3 py-3">
      <div
        className="col-md-12 row  p-4 justify-content-around"
        style={{
          backgroundColor: "white",
          boxShadow: "0px 0px 10px 1px #aaaaaa",
        }}
      >
        <div className="col-md-5 border-table">
          <p className="h2 text-center">
            <strong>{"INFORMACIÓN DE LA MINA"}</strong>
          </p>
          <div className="mx-4 my-4 was-validated">
            <Dimmer active={activate} />
            <div
              className="input-group input-group-sm mb-3"
              style={{ width: 200 }}
            >
              <label
                htmlFor="codigo"
                className="form-label input-group-text"
                id="validationTooltipCodigo"
                style={{ backgroundColor: "#55acee" }}
              >
                Código:
              </label>
              <input
                type="text"
                autoComplete="off"
                onKeyUp={buscarExpendedor}
                ref={txtIdExpendedor}
                name="codigo"
                aria-describedby="validationTooltipCodigo"
                placeholder="Código"
                className="form-control border"
                required
              />
              <button className="btn btn-info" onClick={catalogoExpendedor}>
                <i className="fa fa-search"></i>
              </button>
            </div>
            <h4 className="text-primary">
              <i className="fas fa-user-alt me-2" />
              Mina: {expendedor && expendedor.nombre}
            </h4>
            <hr className="dropdown-divider" />
            <div className="row">
              <div className="col-md-12">
                <ol className="list-unstyled mb-0 pt-0 pb-0">
                  <li className="mb-1">
                    <i className="fas fa-home me-2" />
                    <small>
                      Dirección: {expendedor && expendedor.direccion}{" "}
                    </small>
                  </li>
                  <li className="mb-1">
                    <i className="fas fa-chalkboard-teacher me-2" />
                    <small>
                      N°-Resolución: {expendedor && expendedor.nroresolucion}{" "}
                    </small>
                  </li>
                  <li className="mb-1">
                    <i className="fas fa-id-badge me-2" />
                    <small>
                      N°-Licencia: {expendedor && expendedor.nrolicencia}
                    </small>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 border-table">
          <p className="h2 text-center">
            <strong>{"GUIAS DE MOVILIZACIÓN ASIGNADAS"}</strong>
          </p>

          <div className="row col-md-10 py-5 mx-auto">
            <div className="col-md-12 p-2 mt-4">
              <div className="row col-md-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-2 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    SeleccionarTalonarios(txtIdExpendedor.current.value, 1);
                  }}
                  className="col-md-3 btn btn-success btn-sm rounded-pill"
                >
                  {" "}
                  Activas
                </button>

                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    SeleccionarTalonarios(txtIdExpendedor.current.value, 2);
                  }}
                  className="col-md-3 btn btn-info btn-sm rounded-pill"
                >
                  {" "}
                  Registradas
                </button>

                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    SeleccionarTalonarios(txtIdExpendedor.current.value, 3);
                  }}
                  className="col-md-3 btn btn-danger btn-sm rounded-pill"
                >
                  {" "}
                  Anuladas
                </button>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.idguiadetalle}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.idtalonarioguia}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.codigoguia}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.estatusguia === 1
                            ? "Activa"
                            : item.estatusguia === 2
                            ? "Registrada"
                            : "Anulada"}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.fechausada &&
                            moment(item.fechausada).format("L")}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.estatusguia === 2 ? (
                            <img
                              crossOrigin="anonymous"
                              className="img-fluid"
                              style={{ width: 50, height: 50 }}
                              onClick={(e) => {
                                e.preventDefault();
                                verImagen(item.idguiadetalle + "-guia.jpg");
                              }}
                              src={
                                op.imagenesweb +
                                item.idguiadetalle +
                                "-guia.jpg"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.estatusguia === 2 ? (
                            <img
                              crossOrigin="anonymous"
                              className="img-fluid"
                              style={{ width: 50, height: 50 }}
                              onClick={(e) => {
                                e.preventDefault();
                                verImagen(item.idguiadetalle + "-factura.jpg");
                              }}
                              src={
                                op.imagenesweb +
                                item.idguiadetalle +
                                "-factura.jpg"
                              }
                            />
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          {item.estatusguia === 3
                            ? item.motivodesincorporacion
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>

            <Mensaje
              mensaje={mensaje}
              onHide={() =>
                setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
              }
            />
          </div>
        </div>
      </div>

      <CatalogoAgenteTipo2Web
        show={mostrarcatalogo}
        campoclave={"mina"}
        valorclave={true}
        onHideAceptaCatAge={seleccionarExpendedor}
        onHideCancelaCatAge={cerrarCatalogo}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}

export default GuiasMovilizacionWeb;

/////////////#####$$$$$#####/////////////////
/////#####Generar Planillas#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/components/guiasmovilizacion/gestionarGuiasMovilizacionWeb.js